import React, { useEffect, useState } from "react";

/** Hero slideshow — cycles through the "Catalyst · Team Activity" photos
 * shipped as public CDN assets, auto-advances every ~4.5s (paused on hover),
 * dot indicators are clickable. Falls back to the solid teal→navy gradient
 * from CSS if any image fails to load. */
const SLIDES = [
    "https://customer-assets-0z36b82j.emergentagent.net/job_session-hub-25/artifacts/jxfys0yg_Catalyst%20_%20Team%20Activity%20_%20Photo%20108.webp",
    "https://customer-assets-0z36b82j.emergentagent.net/job_session-hub-25/artifacts/kh2iyl9g_Catalyst%20_%20Team%20Activity%20_%20Photo%20116.webp",
    "https://customer-assets-0z36b82j.emergentagent.net/job_session-hub-25/artifacts/fhw3i49h_Catalyst%20_%20Team%20Activity%20_%20Photo%20180.webp",
];

const Slideshow = () => {
    const [idx, setIdx] = useState(0);
    const [paused, setPaused] = useState(false);
    useEffect(() => {
        if (paused) return;
        const t = setInterval(() => setIdx((i) => (i + 1) % SLIDES.length), 2500);
        return () => clearInterval(t);
    }, [paused]);
    return (
        <div
            className="lh-c2-hero-photo"
            onMouseEnter={() => setPaused(true)}
            onMouseLeave={() => setPaused(false)}
            data-testid="lh-c2-slideshow"
        >
            {SLIDES.map((src, i) => (
                <div
                    key={i}
                    className={`lh-c2-hero-slide ${i === idx ? "active" : ""}`}
                    style={{ backgroundImage: `url(${src})` }}
                    aria-hidden={i !== idx}
                />
            ))}
            <div className="lh-c2-hero-dots">
                {SLIDES.map((_, i) => (
                    <button
                        key={i}
                        className={`lh-c2-hero-dot ${i === idx ? "active" : ""}`}
                        onClick={() => setIdx(i)}
                        aria-label={`Slide ${i + 1}`}
                        data-testid={`lh-c2-slide-dot-${i}`}
                    />
                ))}
            </div>
        </div>
    );
};

export default Slideshow;
